import React from "react";
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker,
	InfoWindow
} from "react-google-maps";
import { createStyles, makeStyles } from "@material-ui/styles";
import {
	Grid,
	Typography,
} from "@material-ui/core";


const useMarkersStyles = makeStyles(() =>
	createStyles({
		root: {
			textAlign: 'center',
			width: ' -webkit-fill-available',
			height: '-webkit-fill-available',
		}
	}),
);

const MyMapComponent = withScriptjs(
	withGoogleMap((props: Props) => {
		const [selectedPlace, setSelectedPlace] = React.useState(null);
		const [zoom, setZoom] = React.useState(10);
		const [infoOpen, setInfoOpen] = React.useState(false);

		const markerClickHandler = (event, place) => {
			setSelectedPlace(place);
			if (infoOpen) {
				setInfoOpen(false);
			}
			setInfoOpen(true);
			if (zoom < 13) {
				setZoom(13);
			}
		};

		return (
			<GoogleMap
				defaultZoom={14}
				defaultCenter={{ lat: parseFloat(props.places[0].latitude), lng: parseFloat(props.places[0].longitude) }}
				zoom={zoom}
			>
				{
					props.places.map((place: any) => (
						<React.Fragment>
							<Marker
								icon={{
									path:
										"M12.75 0l-2.25 2.25 2.25 2.25-5.25 6h-5.25l4.125 4.125-6.375 8.452v0.923h0.923l8.452-6.375 4.125 4.125v-5.25l6-5.25 2.25 2.25 2.25-2.25-11.25-11.25zM10.5 12.75l-1.5-1.5 5.25-5.25 1.5 1.5-5.25 5.25z",
									fillColor: (place.filled >= 70) ? "#F32013" : (place.filled < 40) ? "#4d9b35" : "#ffcc00",
									fillOpacity: 1.0,
									strokeWeight: 0,
									scale: 1.25,
								}}
								position={{ lat: parseFloat(place.latitude), lng: parseFloat(place.longitude) }}
								onClick={marker => markerClickHandler(marker, place)}
							>
							</Marker>
						</React.Fragment>
					))
				}
				{infoOpen && selectedPlace && (
					<InfoWindow
						// @ts-ignore
						position={{ lat: parseFloat(selectedPlace.latitude), lng: parseFloat(selectedPlace.longitude) }}
						onCloseClick={() => setInfoOpen(false)}
					>
						<Grid >
							<Grid item xs={12} sm container>
								<Grid item xs container direction="column" spacing={2}>
									<Grid item xs>
										<Typography gutterBottom variant="h4">
											{
												// @ts-ignore
												selectedPlace.filled + "%"
											}
										</Typography>
										<Typography variant="body2" gutterBottom>
											{
												// @ts-ignore
												selectedPlace.time
											}
										</Typography>
										<Typography variant="body2" color="textSecondary">
											ID:
											{
												// @ts-ignore
												selectedPlace.id
											}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</InfoWindow>
				)}

			</GoogleMap>
		);
	})
);

interface OwnProps {
	places: any,
}

type Props = OwnProps;

function Markers(props: Props) {
	const classes = useMarkersStyles();

	return (
		<div className={classes.root}>
			<MyMapComponent
				// @ts-ignore
				googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAObvSyOfA_D4KjTlp4g2OB6wq4HN9yYts&v=3.exp&libraries=places"
				// @ts-ignore
				loadingElement={<div style={{ height: `100%` }} />}
				// @ts-ignore
				containerElement={<div style={{ height: `100vh` }} />}
				// @ts-ignore
				mapElement={<div style={{ height: `100%` }} />}
				// @ts-ignore
				places={props.location.state.places}
			/>
		</div>
	);
}

export default Markers;
